import classnames from 'classnames';

import styles from './DashboardCTA.module.css';

type DashboardTypes = {
    className?: string;
    icon: React.ReactNode;
    title: React.ReactNode;
    description: React.ReactNode;
    cta?: React.ReactNode;
    'data-testid'?: string;
    fullWidthDescription?: boolean;
};

const DashboardCTA = (props: DashboardTypes) => {
    const { className, icon, title, description, cta, fullWidthDescription } =
        props;

    return (
        <div
            className={classnames(className, styles.container)}
            data-testid={props['data-testid']}
        >
            <div className={styles.icon}>{icon}</div>
            <div className={styles.textContainer}>
                <div>
                    <div className={styles.title}>{title}</div>
                    <div
                        className={`${styles.description} ${
                            fullWidthDescription
                                ? styles.fullWidthDescription
                                : ''
                        }`}
                    >
                        {description}
                    </div>
                </div>
                <div className={styles.cta}>{cta}</div>
            </div>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default DashboardCTA;
